const backStack: string[] = []
const forwardStack: string[] = []
let direction: 'back' | 'forward' | null = null

export function pushPage(url: string) {
  if (direction === 'back') {
    direction = null
    return
  }
  if (direction === 'forward') {
    direction = null
    return
  }
  if (backStack[backStack.length - 1] === url) return
  backStack.push(url)
  forwardStack.length = 0
}

export function goBack(): string | null {
  if (backStack.length <= 1) return null
  const current = backStack.pop()!
  forwardStack.push(current)
  direction = 'back'
  return backStack[backStack.length - 1] ?? null
}

export function goForward(): string | null {
  if (forwardStack.length === 0) return null
  const next = forwardStack.pop()!
  backStack.push(next)
  direction = 'forward'
  return next
}

export function canGoBack(): boolean {
  return backStack.length > 1
}

export function canGoForward(): boolean {
  return forwardStack.length > 0
}
